module.exports = __webpack_public_path__ + "img/couples-053.4c7253ac.jpg";